import { ICustomer } from '../../../data/entities/customer';
import { IFinancial } from '../../../data/entities/customer/financial';
import { ActionTypeNames, ActionValues, createActionCreators } from '../../../store/actions';

export const customerForEditActions = createActionCreators<
	{ T: 'CUSTOMER_UI_CHANGED', P: {id: string, customer: ICustomer} },
	{ T: 'CUSTOMER_FINANCIAL_UI_CHANGED', P: {id: string, financial: IFinancial}}
	>('CUSTOMER_UI_CHANGED', 'CUSTOMER_FINANCIAL_UI_CHANGED');

const actions = { ...customerForEditActions };
type CustomerActions = ActionValues<typeof actions>;
type CustomerActionTypes = ActionTypeNames<CustomerActions>;
export type Actions = CustomerActions[keyof CustomerActions];
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as CustomerActionTypes);
